import { cloneElement, forwardRef, useId } from 'react';

export const Tooltip = forwardRef(function Tooltip(
  { content, children, side = 'bottom', ...triggerProps },
  ref,
) {
  const id = useId();
  const position = side === 'top'
    ? 'bottom-[calc(100%+0.45rem)]'
    : 'top-[calc(100%+0.45rem)]';

  return (
    <span className="group relative inline-flex">
      {cloneElement(children, { ...triggerProps, ref, 'aria-describedby': id })}
      <span
        id={id}
        role="tooltip"
        className={`pointer-events-none absolute left-1/2 z-50 -translate-x-1/2 whitespace-nowrap rounded-md bg-[rgba(var(--fg),0.94)] px-2 py-1 text-xs font-medium text-[rgb(var(--bg))] opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100 ${position}`}
      >
        {content}
      </span>
    </span>
  );
});

export default Tooltip;
